






import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { OsVersionOPtionsType } from './types';
import OsVersion from './index';

const name = 'ttam-os-version-compose';
export default defineComponent({
  name,
  components: {
    TtamOsVersion: OsVersion.TtamOsVersion,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    options: {
      type: Array as PropType<OsVersionOPtionsType>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData } = toRefs(props);
    const _osVersionUnionFakeId = computed({
      get: () => adgroupData.value.osVersionFakeId,
      set: val => {
        emit('change', val);
      },
    });
    OsVersion.useDataSource({ adgroupData, campaignData });
    const { osVersionOptions } = OsVersion.useOsvOptions({
      campaignData,
      adgroupData,
    });
    const resultOptions = computed(() => (props.options?.length ? props.options : osVersionOptions.value));
    return {
      name,
      _osVersionUnionFakeId,
      resultOptions,
    };
  },
});
